var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdinTdfxme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1365 17V24",
    stroke: "#006D33",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1365 20V24M18.1365 20C18.1365 18.3431 19.4796 17 21.1365 17C22.7934 17 24.1365 18.3431 24.1365 20V24M18.1365 20V17",
    stroke: "#006D33",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1445 14H14.1355",
    stroke: "#006D33",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63647 19C9.63647 14.5217 9.63647 12.2825 11.0277 10.8912C12.419 9.5 14.6581 9.5 19.1365 9.5C23.6148 9.5 25.854 9.5 27.2453 10.8912C28.6365 12.2825 28.6365 14.5217 28.6365 19C28.6365 23.4783 28.6365 25.7175 27.2453 27.1088C25.854 28.5 23.6148 28.5 19.1365 28.5C14.6581 28.5 12.419 28.5 11.0277 27.1088C9.63647 25.7175 9.63647 23.4783 9.63647 19Z",
    stroke: "#006D33",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinTdfxme);
export default __webpack_public_path__ + "static/media/linkdin_tdfxme.f164994cdb9050aa3748ef6c12f2b052.svg";
export { ForwardRef as ReactComponent };